import { FIRST_NAME_LABEL, LAST_NAME_LABEL, EMAIL_LABEL } from 'common/constants/nameInputLabels';

/**
 * Labels of questions with special behaviors.
 */
export { FIRST_NAME_LABEL, LAST_NAME_LABEL, EMAIL_LABEL };
export const ATTENDING_LABEL = 'Are you attending?';
export const ADDITIONAL_GUEST_FIRST_NAME_LABEL = `Guest ${FIRST_NAME_LABEL}`;
export const ADDITIONAL_GUEST_LAST_NAME_LABEL = `Guest ${LAST_NAME_LABEL}`;
export const ADDITIONAL_GUEST_EMAIL_LABEL = `Guest ${EMAIL_LABEL}`;
export const ADDITIONAL_GUEST_COUNT_LABEL = 'Additional Guest Count';
export const CHECK_IN_LABEL = 'Check-in';
export const CHECK_OUT_LABEL = 'Check-out';
export const CC_EMAIL_LABEL = 'CC Email';
export const BCC_EMAIL_LABEL = 'BCC Email';
